import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';

interface VariantCombinationPickerProps {
	variatorValues: any[];
	variantOneValue: string;
	variantTwoValue: string;
	onVariantOneChange: (value: string) => void;
	onVariantTwoChange: (value: string) => void;
	product: any;
}

export const useVariantPicker = (product: any) => {
	const getPickerValueForVariant = (variator: string) => {
		const pickerValue = Object.values(
			product?.productId?.option?.variatorValues?.find(
				(data: any) => data?.variator === variator
			)?.variatorValues || {}
		)?.map((data: any) => data?.text);
		return pickerValue || [];
	};

	return {
		getPickerValueForVariant,
	};
};

const VariantCombinationPicker: React.FC<VariantCombinationPickerProps> = ({
	variatorValues,
	variantOneValue,
	variantTwoValue,
	onVariantOneChange,
	onVariantTwoChange,
	product,
}) => {
	const { getPickerValueForVariant } = useVariantPicker(product);

	return (
		<>
			{variatorValues?.map((data, index) => (
				<View key={`variant-${index}`} style={styles.variantContainer}>
					<View style={styles.pickerContainer}>
						<Picker
							style={styles.picker}
							selectedValue={
								index === 0
									? product?.variantType
									: product?.associatedVariantType
							}
							onValueChange={itemValue => {
								if (index === 0) {
									onVariantOneChange(itemValue);
								} else if (index === 1) {
									onVariantTwoChange(itemValue);
								}
							}}
						>
							{[
								...new Set(
									getPickerValueForVariant(data?.variator)
								),
							].map(val => (
								<Picker.Item
									key={val}
									label={val}
									value={val}
								/>
							))}
						</Picker>
					</View>
				</View>
			))}
		</>
	);
};

const styles = StyleSheet.create({
	variantContainer: {
		marginBottom: 0,
	},
	pickerContainer: {
		width: '100%',
	},
	picker: {
		width: '100%',
		height: 20,
		borderColor: 'grey',
		borderRadius: 5,
	},
});

export default VariantCombinationPicker;
